module.exports = __webpack_public_path__ + "static/media/board.8576071f.png";